<template>

    <div class="container">

        <div class="handle-box-search">
            <el-row class="head-search">


                <el-col :span="8">
                    <span class="title">评价星级:</span>


                    <el-select v-model="search_data.star_point" placeholder="请选择类型" style="width: 200px; margin-right: 20px;"
                               clearable>
                        <el-option label="1星" value="1"></el-option>
                        <el-option label="2星" value="2"></el-option>
                        <el-option label="3星" value="3"></el-option>
                        <el-option label="4星" value="4"></el-option>
                        <el-option label="5星" value="5"></el-option>
                    </el-select>
                </el-col>

                <el-col :span="8">
                    <span class="title">类型:</span>

                    <el-select v-model="search_data.type" placeholder="请选择类型" style="width: 200px; margin-right: 20px;"
                               clearable>
                        <el-option label="当前订单" value="0"></el-option>
                        <el-option label="历史订单" value="1"></el-option>
                    </el-select>
                </el-col>


                <el-col :span="24" style="margin-top: 10px;">
                    <span class="title">评价时间:</span>

                    <el-date-picker v-model="search_time" type="datetimerange" range-separator="-" start-placeholder="开始日期"
                                    end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange"
                                    style="width: 300px;">
                    </el-date-picker>
                </el-col>



            </el-row>



            <el-button type="primary" icon="el-icon-search" @click="searchorderAssessList">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
                  @selection-change="handleSelectionChange">

            <el-table-column prop="driver_verify.real_name" label="司机姓名">
            </el-table-column>

            <el-table-column prop="driver.phone" label="电话">
            </el-table-column>


            <el-table-column prop="consumer.name" label="乘客名称">
            </el-table-column>

            <el-table-column prop="consumer.phone" label="乘客电话">
            </el-table-column>

            <el-table-column prop="star_point" label="评价星级">
            </el-table-column>


            <el-table-column prop="synchronization" label="评价标签">
                <template slot-scope="scope">
                    <div v-for="item in JSON.parse(scope.row.synchronization)">{{item.label}}</div>


                </template>
            </el-table-column>





            <el-table-column prop="billno" label="订单号">
            </el-table-column>

            <el-table-column prop="date" label="评价时间">
            </el-table-column>

            <el-table-column prop="is_del" label="状态">
                <template slot-scope="scope">
                    <el-tag type="danger" v-if="scope.row.is_del == '1'">
                        已删除
                    </el-tag>
                    <el-tag type="warning" v-else>
                        未删除
                    </el-tag>

                </template>
            </el-table-column>


                <el-table-column label="操作">
                    <template slot-scope="scope">

                        <el-button split-button type="primary"
                                     @click.native="toDetails(scope.row.order_code,scope.row.driver_code,scope.row.star_point,scope.row.remarks)">

                            查看



                        </el-button>

                    </template>
                </el-table-column>

        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>




        <!-- 添加组件 -->
        <detailsDialog :isShow="details_show" :data="detailsData" @onSubmit="orderAssessList"></detailsDialog>

        <!-- 编辑组件 -->
        <!--        <editDriverDan :isShow="edit_isShow" :data="edit_data" @onSubmit="driverDanLists"></editDriverDan>-->

    </div>

</template>

<script>
    import detailsDialog from './details.vue';
    // import editDriverDan from './editDriverDan.vue';
    var _this;
    export default {
        components: {
            detailsDialog,
            // editDriverDan

        },

        data() {
            return {



                search_time: '',

                details_show:false,

                // 存放表格数据
                tableData: [],
                detailsData:{},

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                    type:'',
                    star_point:'',
                    fixed_array:''
                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    },

                },
            };
        },
        created() {
            _this = this;
            _this.orderAssessList();
        },

        methods: {
            timeChange(val) {
                if(val !== null){
                    _this.search_data.fixed_array = JSON.stringify(['between'].concat(val));

                }else{
                    _this.search_data.fixed_array = ''
                }

            },
            toDetails(order_code,driver_code,star_point,remarks){
                _this.detailsData.order_code = order_code;
                _this.detailsData.driver_code = driver_code;
                _this.detailsData.star_point = star_point;
                _this.detailsData.remarks = remarks;
                _this.details_show = !_this.details_show
            },

            del(order_code,driver_code,star_point) {

                _this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning',

                }).then(() => {

                    _this.$post(
                        "/driver/delOrderAssess", {
                            order_code: order_code,
                            driver_code: driver_code,
                            star_point: star_point
                        }
                    )
                        .then(res => {


                            _this.$message.success(res.msg);
                            _this.orderAssessList();

                        }).catch((err) => {

                    })

                }).catch(() => {

                    _this.$message({
                        message: '已取消删除',
                        duration: 1500
                    });

                });


            },





            searchorderAssessList() {

                _this.search_data.page = 1;
                _this.orderAssessList();

            },
            // 搜索司机日志列表
            orderAssessList() {
                _this.$post(
                    "/driver/orderAssessList",
                    _this.search_data,
                    _this.search_rules
                )
                    .then(res => {


                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;

                    }).catch((err) => {

                })
            },
            //翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.orderAssessList();

            },

            handleSelectionChange(val) {

                var datalist = [];

                for (var i in val) {

                    datalist.push(val[i].driver_code);

                }
                _this.delDriverSubmit_data.driver_code_array = datalist;
            },
            // 刷新按钮
            refresh() {
                this.$router.go(0);
            },

        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-form-item.el-form-item--small {
        width: 100%;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
    }

    .el-form-item__content span {
        display: inline-block;
        width: 100%;
        word-wrap: break-word;
        white-space: normal;
    }
</style>
